require('./modifyMainPhoneView.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { formatText } = require('core/i18n').i18n;

// @components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const ProfilePictureEditor = require('components/myProfile/profilePictureEditor/profilePictureEditor');
const { LoadingSection } = require('commonsComponents/loadingSection');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
const ModifyMainPhoneStep1 = require('./modifyMainPhoneStep1/modifyMainPhoneStep1');
const ModifyMainPhoneStep2 = require('./modifyMainPhoneStep2/modifyMainPhoneStep2');

// @constants
const { WIZARD_VERTICAL_VIEW_MODE } = require('constants/index');
const { MODIFY_MAIN_PHONE } = require('constants/contactCenter/operationTypes');
const translationNamespace = 'modifyMainPhone';

class ModifyMainPhoneView extends React.Component {
    constructor(props) {
        super(props);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleGoBack = this.handleGoBack.bind(this);
    }

    componentDidMount() {
        const { immModifyMainPhone, requestContactPhoneData } = this.props;
        if(!immModifyMainPhone.getIn(['mainContactPhoneData', 'listaDispositivos'])) {
            requestContactPhoneData();
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    buildPreleaveCancelModal() {
        const { immModifyMainPhone } = this.props;
        const showCancelModal = immModifyMainPhone.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={showCancelModal}
                onCancel={this.handleGoBack}
                onCloseModal={this.handleShowCancelModal}
                onStayHere={this.handleShowCancelModal}
            />
        );
    }

    handleShowCancelModal() {
        const { showCancelModal, immModifyMainPhone} = this.props;
        const isVisible = immModifyMainPhone.get('showCancelModal');
        showCancelModal(!isVisible);
    }

    handleGoBack() {
        const cancelPath = '/myprofile/edit';
        this.props.history.push(cancelPath);
    }

    buildHeader() {
        const title = formatText(`${translationNamespace}-title`);

        const breadcrumpMap = [
            {
                text: formatText('profile-titleHeader'),
                url: '/myprofile/edit'
            },
            {
                text: title
            }
        ];

        return (
            <OKHeaderCC
                title={title}
                breadcrumbConfig={breadcrumpMap}
                showBreadBrumb={true}
            />
        );
    }

    handleFinish() {
        const { confirmModifyMainPhone } = this.props;
        confirmModifyMainPhone();
    }

    buildSuccessfulFeedback() {
        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText(`${translationNamespace}-successfulFeedbackTitle`)}
                subtitle={formatText(`${translationNamespace}-successfulFeedbackSubtitle`)}
                textLink={formatText(`${translationNamespace}-feedbackBackButton`)}
                goBackHandler={this.handleGoBack}
            />
        );
    }

    buildErrorFeedback() {
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={formatText(`${translationNamespace}-failureFeedbackTitle`)}
                textLink={formatText(`${translationNamespace}-feedbackBackButton`)}
                goBackHandler={this.handleGoBack}
            />
        );
    }

    buildWizard() {
        const {
            setMainPhone,
            setVisibleStep,
            validateStep,
            immModifyMainPhone,
        } = this.props;

        const currentStep = immModifyMainPhone.get('currentStep');
        const immSteps = immModifyMainPhone.get('steps');
        const isFetching = immModifyMainPhone.get('isFetching');
        const printTitle = "modifyMainPhone-printTitle";

        const actions = {
            finish: this.handleFinish,
            setVisibleStep,
            validateStep,
            setWillCancel: () => {},
            cancel: this.handleShowCancelModal
        };

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={currentStep}
            >

                <WizardStep
                    cancelButton={true}
                >
                    <ModifyMainPhoneStep1 immModifyMainPhone={immModifyMainPhone} setMainPhone={setMainPhone} />
                </WizardStep>

                <WizardStep
                    position="middle"
                    cancelButton={true}
                    omitPreviousButton={false}
                >
                    <ModifyMainPhoneStep2 immModifyMainPhone={immModifyMainPhone} />
                </WizardStep>

                <WizardStep
                    position="last"
                    omitPreviousButton={false}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={isFetching}
                    immFinalButton={`${translationNamespace}-confirm`}
                >
                    <VerifyOtpStep
                        operationType={MODIFY_MAIN_PHONE}
                        operationParams={{}}
                        printTitleValue={printTitle}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildProfilePicture() {
        const { immProfileFields } = this.props;

        return (
            <div className="modify-main-phone__profile-picture">
                <ProfilePictureEditor
                    editable={false}
                    fields={immProfileFields}
                    handleSubmit={()=>{}}
                    onClick={()=>{}}
                    onAliasChange={()=>{}}
                    onChangeModal={()=>{}}
                    setProfileAvatarEditorError={()=>{}}
                />
            </div>
        );
    }

    buildContent() {
        const { immModifyMainPhone } = this.props;
        let pageContent;

        const profilePicture = this.buildProfilePicture();

        if (immModifyMainPhone.get('hasBeenFetched')) {
            pageContent = this.buildSuccessfulFeedback();
        } else if (immModifyMainPhone.get('error')) {
            pageContent = this.buildErrorFeedback();
        } else if(immModifyMainPhone.get('isFetchingData') || !immModifyMainPhone.get('phoneDataFetched')) {
            pageContent = <LoadingSection/>
        } else {
            const wizard = this.buildWizard();
            const preleaveCancelModal = this.buildPreleaveCancelModal();
            const content = (
                <div className="modify-main-phone__content col-xs-12">
                    {profilePicture}
                    {wizard}
                    {preleaveCancelModal}
                </div>
            );
            pageContent = (
                <div>
                    {content}
                </div>
            );
        }

        return pageContent;
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <div className="modify-main-phone">
                {header}
                <div className="modify-main-phone__body">
                    {content}
                </div>
            </div>

        );
    }
}

ModifyMainPhoneView.propTypes = {
    history: PropTypes.object.isRequired,
    immModifyMainPhone: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    setMainPhone: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    confirmModifyMainPhone: PropTypes.func.isRequired,
    requestContactPhoneData: PropTypes.func.isRequired,
};

module.exports = withRouter(ModifyMainPhoneView);
